var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44444 14H12.5556C13.3533 14 14 13.3533 14 12.5556V2.44444C14 1.6467 13.3533 1 12.5556 1H2.44444C1.6467 1 1 1.6467 1 2.44444V12.5556C1 13.3533 1.6467 14 2.44444 14ZM2.44444 14L10.3889 6.05556L14 9.66667M6.05556 4.97222C6.05556 5.57053 5.57053 6.05556 4.97222 6.05556C4.37391 6.05556 3.88889 5.57053 3.88889 4.97222C3.88889 4.37391 4.37391 3.88889 4.97222 3.88889C5.57053 3.88889 6.05556 4.37391 6.05556 4.97222Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidence);
export default __webpack_public_path__ + "static/media/evidence.5d6c6bbd0c0a829252ffe2de516228c9.svg";
export { ForwardRef as ReactComponent };